import Flexbox from './flexbox'
import FlexboxItem from './flexbox-item'

export {
  Flexbox,
  FlexboxItem
}



// WEBPACK FOOTER //
// ./src/components/flexbox/index.js